export const CATEGORIES = [
  "Geral",
  "Avisos",
  "Faturas",
  "Suporte",
  "Comercial",
  "Outros",
];
